import React from 'react';
import { Table } from 'semantic-ui-react';
import RowAddButton from '@/components/buttons/RowAddButton';

const MembersTableHeaderAddRow = ({
  children,
  colSpan = 1,
  disabled,
  entity,
  extraContent = undefined,
  onClick,
}) => (
  <Table.Row
    className="aridhia-table-header-add-row relative z-1"
    verticalAlign="top"
  >
    <Table.HeaderCell colSpan={colSpan} className="top-33 z-10">{children}</Table.HeaderCell>
    {extraContent}
    <Table.HeaderCell className="top-33 z-10" collapsing>
      <RowAddButton disabled={disabled} entity={entity} onClick={onClick} />
    </Table.HeaderCell>
  </Table.Row>
);

export default MembersTableHeaderAddRow;
